import React from 'react';
import './DeckCollection.css';
import { ReactComponent as BookShelfIcon } from '../../Icons/book-shelf.svg';
import { ReactComponent as CookbookStatIcon } from '../../Icons/book.svg';

import OptionsMenu from './OptionsMenu';

/** Match cookbook card title truncation (`DeckManager.truncateDeckManagerTitle`). */
function truncateDeckCollectionTitle(title, maxLength = 85) {
  if (!title) return '';
  if (title.length <= maxLength) return title;
  return `${title.substring(0, maxLength).trim()}...`;
}

const DeckCollection = ({ collection, onSelect, onDelete, onRename, tagFilter }) => {
  const deckCount = collection.deckCount || 0;

  return (
    <div
      className="deck-collection-card deck-manager-deck-item"
      onClick={() => onSelect(collection.id)}
    >
      <div className="deck-collection-card__main">
        <div className="deck-collection-card__leading">
          <span className="deck-collection-card__icon-wrap" aria-hidden>
            <BookShelfIcon className="deck-collection-card__icon" />
          </span>
          <h3 className="deck-collection-card__title">
            {truncateDeckCollectionTitle(collection.name)}
          </h3>
        </div>
        <div className="deck-collection-card__trailing">
          <div
            className="deck-collection-card__stat"
            title={`${deckCount} ${deckCount === 1 ? 'cookbook' : 'cookbooks'}`}
            aria-label={`${deckCount} ${deckCount === 1 ? 'cookbook' : 'cookbooks'}`}
          >
            <span className="deck-collection-card__stat-icon-wrap" aria-hidden>
              <CookbookStatIcon className="deck-collection-card__stat-icon" />
            </span>
            <span className="deck-collection-card__stat-value">{deckCount}</span>
          </div>
        </div>
      </div>

      {collection.tags && collection.tags.length > 0 ? (
        <div className="deck-collection-card__tags">
          {collection.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className={`deck-collection-card__tag ${tagFilter === tag ? 'deck-collection-card__tag--active' : ''}`}
            >
              {tag}
            </span>
          ))}
        </div>
      ) : null}

      <div className="deck-dropdown">
        <OptionsMenu
          options={[
            {
              label: "Rename",
              onClick: (e) => {
                e.stopPropagation();
                const newName = prompt('Enter new collection name:', collection.name);
                if (newName && newName.trim()) {
                  onRename(collection.id, newName.trim());
                }
              }
            },
            {
              label: "Delete",
              onClick: (e) => {
                e.stopPropagation();
                if (window.confirm('Are you sure you want to delete this collection?')) {
                  onDelete(collection.id);
                }
              },
              className: "delete"
            }
          ]}
        />
      </div>
    </div>
  );
};

export default DeckCollection;
